import { useState } from 'react'

export const useImageFallback = (src?: string) => {
  const [failedSrc, setFailedSrc] = useState<string>()

  return {
    hasError: !src || failedSrc === src,
    onError: () => setFailedSrc(src),
  }
}
